import { debounce } from '../utils/debounce'

export default () => ({
	// State
	hasValue: false,

	init() {
		this.$refs.form?.addEventListener('reset', this.onFormReset.bind(this))

		this.$refs.input?.addEventListener(
			'input',
			debounce(event => {
				this.onChange(event)
			}, 300).bind(this),
		)
	},

	onChange() {
		this.hasValue = this.$refs.input.value.length > 0
	},

	shouldResetForm() {
		return !document.querySelector('[aria-selected="true"] a')
	},

	onFormReset(event) {
		// Prevent default so the form reset doesn't set the value gotten from the url on page load
		event.preventDefault()

		// Don't reset if the user has selected an element on the predictive search dropdown
		if (this.shouldResetForm()) {
			this.$refs.input.value = ''
			this.$refs.input.focus()
			this.hasValue = false
		}
	},

	destroy() {
		this.$refs.form.removeEventListener('reset', this.onFormReset)
		// Note: The input listener will be automatically cleaned up by debounce
	},
})
